<<<<<<< HEAD
<template>
    <div class="my-attention" v-loading="loading">
        <tab-header
            :tabList="attenTionTabList"
            :tabName="tabName"
            :isSort="false"
            :isSelf="isSelf"
            @getTabName="getTabName">
        </tab-header>
        <section class="attenTion-content" v-loading="isLoading">
            <ul class="attenTion-list" v-if="attenTionList.length">
                <li
                class="attenTion-item"
                v-for="(attention, index) in attenTionList"
                :key="index">
                    <div class="attenTion-left">
                        <img
                            class="avatar"
                            src="../../images/personal_center/avatar_default.png"
                            v-if="attention.avatar.substr(0,1) === '?'"
                            @click.stop="goHomePage(attention.user_id)">
                        <img v-else class="avatar" @click="goHomePage(attention.user_id)" :src="attention.avatar" alt="">
                        <div class="user-info">
                            <p class="user-top" @click="goHomePage(attention.user_id)">
                                <span class="nick-name">{{ attention.nick_name }}</span>
                                <span v-if="isLogin && attention.is_followed === null" class="is-self">我自己</span>
                                <el-tooltip v-if="attention.is_vip" effect="light" content="核心用户标识" placement="right">
                                    <span style="margin-left: 2px" class="icon-vipuser"></span>
                                </el-tooltip>
                            </p>
                            <div class="statistics-info">
                                <p><span class="num">{{ attention.qa_num }}</span>个问题</p>
                                <p><span class="num">{{ attention.comment_num }}</span>个回答</p>
                                <p><span class="num">{{ attention.article_num }}</span>篇文章</p>
                                <p><span class="num">{{ attention.saas_num }}</span>个作品</p>
                            </div>
                        </div>
                    </div>
                    <div class="attenTion-right">
                        <p class="follow-time">
                            关注时间：
                            <span>{{ attention.follow_time || '--' }}</span>
                        </p>
                        <el-tooltip
                            v-if="!isLogin || attention.is_followed !== null"
                            effect="dark"
                            content="取消关注"
                            :disabled="!((isSelf ? tabName === 'follow_me' : true) && attention.is_mutual_follow)"
                            placement="top">
                            <p :class="['attenTion-btn', attention.className]" @click="handleToggleAttention(attention)">
                                <template v-if="attention.className.indexOf('follow-me') !== -1">
                                    <img v-if="attention.is_mutual_follow" class="sort-img" src="../../images/personal_center/sort.png" alt="">
                                    <img v-else class="add-img" src="../../images/personal_center/plus-line.png" alt="">
                                </template>
                                <template v-if="isSelf">
                                    {{ !isLogin ? '关注' : attention.className === 'my-follow' ? '取消关注' : attention.is_mutual_follow ? '互相关注' : '关注' }}
                                </template>
                                <template v-else>
                                    {{ attention.is_mutual_follow
                                        ? '互相关注'
                                        : attention.is_followed
                                        ? '取消关注'
                                        : '关注' }}
                                </template>
                            </p>
                        </el-tooltip>
                    </div>
                </li>
            </ul>
            <!-- 无数据 -->
            <div class="content-empty" v-show="!attenTionList.length && !isLoading">
                <img src="../../images/personal_center/data-null.png" alt="" />
                <p>暂无数据</p>
            </div>
            <!-- 滚动加载loading -->
            <div class="load-more" v-if="isMoreLoading || attenTionList.length > 10">
                <img v-if="isMoreLoading" alt="loadding" src="../../images/common/loading_2_24x24.gif">
                <span v-else>{{ totalPage === curPage ? '没有更多内容了' : '显示更多' }}</span>
            </div>
        </section>
    </div>
</template>
<script>
import tabHeader from './tabHeader.vue'
import personalCenter from '@/mixins/personalCenter.js'
export default {
    components: { tabHeader },
    mixins: [ personalCenter ],
    data () {
        return {
            attenTionTabList: [
                {
                    label: '关注我的人',
                    name: 'follow_me',
                    count: 0,
                    special: true
                },
                {
                    label: '关注的人',
                    name: 'my_follow',
                    count: 0
                }
            ],
            attenTionList: [],
            tabName: 'follow_me'
        }
    },
    watch: {
        statisticsInfo: {
            handler (val) {
                if (!val) return
                // 设置默认条数
                this.attenTionTabList.forEach(item => {
                    const type = item.name === 'follow_me'
                        ? 'fan_num'
                        : 'star_num'
                    item.count = this.statisticsInfo[type]
                })
            },
            immediate: true
        }
    },
    methods: {
        // 切换tab
        getTabName (name) {
            this.tabName = name || 'follow_me'
            this.curPage = 1
            this.getFollowList()
        },
        // 获取我关注用户列表
        async getFollowList (tabName = this.tabName, isMore) {
            try {
                if (isMore) {
                    this.isMoreLoading = true
                } else {
                    this.isLoading = !this.loading // 获取所有tab数据的时候不需要单独加载loading
                }
                const params = {
                    page: this.curPage,
                    page_size: 10
                }
                const path = `profile/user/${this.userId}/${tabName === 'follow_me' ? 'fan' : 'star'}/`
                await axios.get(myUrl + path, { params }).then((res) => {
                    const resp = res.data
                    if (!resp.result) return
                    
                    // 设置tab关注数
                    const tab = this.attenTionTabList.find(item => item.name === tabName)
                    tab.count = resp.data.count

                    // 添加用户列表
                    this.totalPage = Math.ceil(resp.data.count / 10)
                    this.isPageOver = this.curPage >= this.totalPage

                    const dataList = resp.data.results.map(item => {
                        if (!this.isLogin) {
                            item.className = 'follow-me'
                        } else if (this.isSelf) {
                            item.className = this.tabName === 'follow_me' ? item.is_mutual_follow ? 'each-other follow-me' : 'follow-me' : 'my-follow'
                        } else {
                            item.className = item.is_mutual_follow
                                ? 'each-other follow-me'
                                : item.is_followed
                                ? 'my-follow'
                                : item.is_followed === null
                                ? 'is-me'
                                : 'follow-me'
                        }
                        return item
                    })
                    if (isMore) {
                        this.attenTionList.push(...dataList)
                    } else {
                        this.attenTionList = dataList
                    }
                })
            } catch (error) {
                console.warn(error)
            } finally {
                this.loading = false
                this.isLoading = false
                this.isMoreLoading = false
            }
        },
        // 切换关注/取消关注
        handleToggleAttention (attention) {
            try {
                if (!this.isLogin) {
                    axios.get(myUrl + 'login/test/')
                    return
                }
                if (attention.is_followed === null) return
                const path = attention.is_mutual_follow || this.tabName === 'my_follow' ? 'sns/unstar/user/' : 'sns/star/user/'
                axios.post(myUrl + path + attention.user_id + "/").then((res) =>{
                    const resp = res.data
                    if(!resp.result) return
                    if (this.isSelf && this.tabName === 'my_follow') {
                        const index = this.attenTionList.findIndex(item => item.user_id === attention.user_id)
                        this.attenTionList.splice(index, 1)
                        // 设置tab关注数
                        const tab = this.attenTionTabList.find(item => item.name === this.tabName)
                        tab.count--
                    }
                    attention.is_mutual_follow = !attention.is_mutual_follow
                    attention.className = this.tabName === 'follow_me' ? attention.is_mutual_follow ? 'each-other follow-me' : 'follow-me' : 'my-follow'
                    this.$message({
                        message: attention.is_mutual_follow ? '关注成功！' : '取消关注成功！',
                        type: 'success'
                    })
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 前往个人主页
        goHomePage (userId) {
            let routeData = this.$router.resolve({
                path: `/s-mart/personal_center/user/${userId}`,
            })
            window.open(routeData.href, '_blank')
        },
        // 监听滚动
        handleScroll () {
            // 滚动加载
            this.scrollLoading(this.getFollowList)
        }
    }
}
</script>

<style lang="scss">
    .my-attention {
        .el-loading-mask {
            .el-loading-spinner {
                top: 170px !important;
            }
        }
    }
</style>
<style media="screen" lang="scss">
    .my-attention {
        width: 1200px;
        margin: 0 auto 17px;
        background: #fff;
        .attenTion-content {
            padding: 5px 14px 20px 25px;
            min-height: 320px;
        }
        .attenTion-item {
            height: 73px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
            border-bottom: 1px solid #f0f1f5;
            .attenTion-left {
                align-self: start;
                display: flex;
                align-items: center;
                .avatar {
                    height: 50px;
                    width: 50px;
                    border-radius: 50%;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .user-info {
                    .user-top {
                        display: flex;
                        align-items: center;
                        margin-bottom: 9px;
                        .nick-name {
                            font-size: 16px;
                            line-height: 18px;
                            color: #313238;
                            font-weight: 700;
                            cursor: pointer;
                        }
                        .is-self {
                            width: 40px;
                            height: 18px;
                            text-align: center;
                            line-height: 18px;
                            background: #edf4ff;
                            border-radius: 2px;
                            color: #3a84ff;
                            font-size: 12px;
                            transform: scale(.8);
                            margin-left: 5px;
                        }
                    }
                    .statistics-info {
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #63656e;
                        p {
                            margin-right: 20px;
                            position: relative;
                            &:not(:last-child)::after {
                                content: '';
                                position: absolute;
                                right: -12px;
                                top: 8px;
                                width: 4px;
                                height: 4px;
                                background: #979ba5;
                                border-radius: 50%;
                            }
                            .num {
                                font-weight: 700;
                                margin-right: 5px;
                            }
                        }
                    }
                }
            }
            .attenTion-right {
                display: flex;
                align-items: center;
                font-size: 12px;
                padding: 0 20px 5px 0;
                .follow-time {
                    color: #979ba5;
                    span {
                        display: inline-block;
                        width: 120px;
                        text-align: left;
                    }
                }
                .attenTion-btn {
                    width: 86px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 2px;
                    margin-left: 10px;
                    font-size: 14px;
                    color: #fff;
                    cursor: pointer;
                    .add-img {
                        height: 14px;
                        width: 14px;
                        margin-right: 5px;
                    }
                    .sort-img {
                        transform: rotate(90deg);
                        height: 16px;
                        width: 16px;
                        margin-right: 2px;
                    }
                    &.is-me {
                        cursor: not-allowed;
                        background: #c4c6cc;
                        border-color: #c4c6cc;
                        color: #fff;
                    }
                    &.follow-me {
                        background: #3a84ff;
                        border: 1px solid #3a84ff;
                        &:hover {
                            background: #699df4;
                            border-color: #699df4;
                        }
                    }
                    &.my-follow {
                        border: 1px solid #c4c6cc;
                        background: #fff;
                        color: #63656e;
                        &:hover {
                            border-color: #979ba5;
                        }
                    }
                    &.each-other {
                        background: #c4c6cc;
                        border-color: #c4c6cc;
                        color: #fff;
                        &:hover {
                            border-color: #c4c6cc;
                            background: #c4c6cc;
                        }
                    }
                }
            }
        }
    }
</style>
=======
<template>
    <div class="my-attention" v-loading="loading">
        <tab-header
            :tabList="attenTionTabList"
            :tabName="tabName"
            :isSort="false"
            :isSelf="isSelf"
            @getTabName="getTabName">
        </tab-header>
        <section class="attenTion-content" v-loading="isLoading">
            <ul class="attenTion-list" v-if="attenTionList.length">
                <li
                class="attenTion-item"
                v-for="(attention, index) in attenTionList"
                :key="index">
                    <div class="attenTion-left">
                        <img
                            class="avatar"
                            src="../../images/personal_center/avatar_default.png"
                            v-if="attention.avatar.substr(0,1) === '?'"
                            @click.stop="goHomePage(attention.user_id)">
                        <img v-else class="avatar" @click="goHomePage(attention.user_id)" :src="attention.avatar" alt="">
                        <div class="user-info">
                            <p class="user-top" @click="goHomePage(attention.user_id)">
                                <span class="nick-name">{{ attention.nick_name }}</span>
                                <span v-if="isLogin && attention.is_followed === null" class="is-self">我自己</span>
                                <el-tooltip v-if="attention.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                                    <svg style="width: 20px; height: 20px" aria-hidden="true">
                                        <use xlink:href="#icon-lanjingguanfang"></use>
                                    </svg>
                                </el-tooltip>
                                <el-tooltip v-if="attention.is_vip" effect="light" content="核心用户" placement="right">
                                    <span style="margin-left: 2px" class="icon-vipuser"></span>
                                </el-tooltip>
                            </p>
                            <div class="statistics-info">
                                <p><span class="num">{{ attention.qa_num }}</span>个问题</p>
                                <p><span class="num">{{ attention.comment_num }}</span>个回答</p>
                                <p><span class="num">{{ attention.article_num }}</span>篇文章</p>
                                <p><span class="num">{{ attention.saas_num }}</span>个作品</p>
                            </div>
                        </div>
                    </div>
                    <div class="attenTion-right">
                        <p class="follow-time">
                            关注时间：
                            <span>{{ attention.follow_time || '--' }}</span>
                        </p>
                        <el-tooltip
                            v-if="!isLogin || attention.is_followed !== null"
                            effect="dark"
                            content="取消关注"
                            :disabled="!((isSelf ? tabName === 'follow_me' : true) && attention.is_mutual_follow)"
                            placement="top">
                            <p :class="['attenTion-btn', attention.className]" @click="handleToggleAttention(attention)">
                                <template v-if="attention.className.indexOf('follow-me') !== -1">
                                    <img v-if="attention.is_mutual_follow" class="sort-img" src="../../images/personal_center/sort.png" alt="">
                                    <img v-else class="add-img" src="../../images/personal_center/plus-line.png" alt="">
                                </template>
                                <template v-if="isSelf">
                                    {{ !isLogin ? '关注' : attention.className === 'my-follow' ? '取消关注' : attention.is_mutual_follow ? '互相关注' : '关注' }}
                                </template>
                                <template v-else>
                                    {{ attention.is_mutual_follow
                                        ? '互相关注'
                                        : attention.is_followed
                                        ? '取消关注'
                                        : '关注' }}
                                </template>
                            </p>
                        </el-tooltip>
                    </div>
                </li>
            </ul>
            <!-- 无数据 -->
            <div class="content-empty" v-show="!attenTionList.length && !isLoading">
                <img src="../../images/personal_center/data-null.png" alt="" />
                <p>暂无数据</p>
            </div>
            <!-- 滚动加载loading -->
            <div class="load-more" v-if="isMoreLoading || attenTionList.length > 10">
                <img v-if="isMoreLoading" alt="loadding" src="../../images/common/loading_2_24x24.gif">
                <span v-else>{{ totalPage === curPage ? '没有更多内容了' : '显示更多' }}</span>
            </div>
        </section>
    </div>
</template>
<script>
import tabHeader from './tabHeader.vue'
import personalCenter from '@/mixins/personalCenter.js'
export default {
    components: { tabHeader },
    mixins: [ personalCenter ],
    data () {
        return {
            attenTionTabList: [
                {
                    label: '关注我的人',
                    name: 'follow_me',
                    count: 0,
                    special: true
                },
                {
                    label: '关注的人',
                    name: 'my_follow',
                    count: 0
                }
            ],
            attenTionList: [],
            tabName: 'follow_me'
        }
    },
    watch: {
        statisticsInfo: {
            handler (val) {
                if (!val) return
                // 设置默认条数
                this.attenTionTabList.forEach(item => {
                    const type = item.name === 'follow_me'
                        ? 'fan_num'
                        : 'star_num'
                    item.count = this.statisticsInfo[type]
                })
            },
            immediate: true
        }
    },
    methods: {
        // 切换tab
        getTabName (name) {
            this.tabName = name || 'follow_me'
            this.curPage = 1
            this.getFollowList()
        },
        // 获取我关注用户列表
        async getFollowList (tabName = this.tabName, isMore) {
            try {
                if (isMore) {
                    this.isMoreLoading = true
                } else {
                    this.isLoading = !this.loading // 获取所有tab数据的时候不需要单独加载loading
                }
                const params = {
                    page: this.curPage,
                    page_size: 10
                }
                const path = `profile/user/${this.userId}/${tabName === 'follow_me' ? 'fan' : 'star'}/`
                await axios.get(myUrl + path, { params }).then((res) => {
                    const resp = res.data
                    if (!resp.result) return
                    
                    // 设置tab关注数
                    const tab = this.attenTionTabList.find(item => item.name === tabName)
                    tab.count = resp.data.count

                    // 添加用户列表
                    this.totalPage = Math.ceil(resp.data.count / 10)
                    this.isPageOver = this.curPage >= this.totalPage

                    const dataList = resp.data.results.map(item => {
                        if (!this.isLogin) {
                            item.className = 'follow-me'
                        } else if (this.isSelf) {
                            item.className = this.tabName === 'follow_me' ? item.is_mutual_follow ? 'each-other follow-me' : 'follow-me' : 'my-follow'
                        } else {
                            item.className = item.is_mutual_follow
                                ? 'each-other follow-me'
                                : item.is_followed
                                ? 'my-follow'
                                : item.is_followed === null
                                ? 'is-me'
                                : 'follow-me'
                        }
                        return item
                    })
                    if (isMore) {
                        this.attenTionList.push(...dataList)
                    } else {
                        this.attenTionList = dataList
                    }
                })
            } catch (error) {
                console.warn(error)
            } finally {
                this.loading = false
                this.isLoading = false
                this.isMoreLoading = false
            }
        },
        // 切换关注/取消关注
        handleToggleAttention (attention) {
            try {
                if (!this.isLogin) {
                    axios.get(myUrl + 'login/test/')
                    return
                }
                if (attention.is_followed === null) return
                const path = attention.is_mutual_follow || this.tabName === 'my_follow' ? 'sns/unstar/user/' : 'sns/star/user/'
                axios.post(myUrl + path + attention.user_id + "/").then((res) =>{
                    const resp = res.data
                    if(!resp.result) return
                    if (this.isSelf && this.tabName === 'my_follow') {
                        const index = this.attenTionList.findIndex(item => item.user_id === attention.user_id)
                        this.attenTionList.splice(index, 1)
                        // 设置tab关注数
                        const tab = this.attenTionTabList.find(item => item.name === this.tabName)
                        tab.count--
                    }
                    attention.is_mutual_follow = !attention.is_mutual_follow
                    attention.className = this.tabName === 'follow_me' ? attention.is_mutual_follow ? 'each-other follow-me' : 'follow-me' : 'my-follow'
                    this.$message({
                        message: attention.is_mutual_follow ? '关注成功！' : '取消关注成功！',
                        type: 'success'
                    })
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 前往个人主页
        goHomePage (userId) {
            let routeData = this.$router.resolve({
                path: `/s-mart/personal_center/user/${userId}`,
            })
            window.open(routeData.href, '_blank')
        },
        // 监听滚动
        handleScroll () {
            // 滚动加载
            this.scrollLoading(this.getFollowList)
        }
    }
}
</script>

<style lang="scss">
    .my-attention {
        .el-loading-mask {
            .el-loading-spinner {
                top: 170px !important;
            }
        }
    }
</style>
<style media="screen" lang="scss">
    .my-attention {
        width: 1200px;
        margin: 0 auto 17px;
        background: #fff;
        .attenTion-content {
            padding: 5px 14px 20px 25px;
            min-height: 320px;
        }
        .attenTion-item {
            height: 73px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
            border-bottom: 1px solid #f0f1f5;
            .attenTion-left {
                align-self: start;
                display: flex;
                align-items: center;
                .avatar {
                    height: 50px;
                    width: 50px;
                    border-radius: 50%;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .user-info {
                    .user-top {
                        display: flex;
                        align-items: center;
                        margin-bottom: 9px;
                        .nick-name {
                            font-size: 16px;
                            line-height: 18px;
                            color: #313238;
                            font-weight: 700;
                            cursor: pointer;
                        }
                        .is-self {
                            width: 40px;
                            height: 18px;
                            text-align: center;
                            line-height: 18px;
                            background: #edf4ff;
                            border-radius: 2px;
                            color: #3a84ff;
                            font-size: 12px;
                            transform: scale(.8);
                            margin-left: 5px;
                        }
                    }
                    .statistics-info {
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #63656e;
                        p {
                            margin-right: 20px;
                            position: relative;
                            &:not(:last-child)::after {
                                content: '';
                                position: absolute;
                                right: -12px;
                                top: 8px;
                                width: 4px;
                                height: 4px;
                                background: #979ba5;
                                border-radius: 50%;
                            }
                            .num {
                                font-weight: 700;
                                margin-right: 5px;
                            }
                        }
                    }
                }
            }
            .attenTion-right {
                display: flex;
                align-items: center;
                font-size: 12px;
                padding: 0 20px 5px 0;
                .follow-time {
                    color: #979ba5;
                    span {
                        display: inline-block;
                        width: 120px;
                        text-align: left;
                    }
                }
                .attenTion-btn {
                    width: 86px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 2px;
                    margin-left: 10px;
                    font-size: 14px;
                    color: #fff;
                    cursor: pointer;
                    .add-img {
                        height: 14px;
                        width: 14px;
                        margin-right: 5px;
                    }
                    .sort-img {
                        transform: rotate(90deg);
                        height: 16px;
                        width: 16px;
                        margin-right: 2px;
                    }
                    &.is-me {
                        cursor: not-allowed;
                        background: #c4c6cc;
                        border-color: #c4c6cc;
                        color: #fff;
                    }
                    &.follow-me {
                        background: #3a84ff;
                        border: 1px solid #3a84ff;
                        &:hover {
                            background: #699df4;
                            border-color: #699df4;
                        }
                    }
                    &.my-follow {
                        border: 1px solid #c4c6cc;
                        background: #fff;
                        color: #63656e;
                        &:hover {
                            border-color: #979ba5;
                        }
                    }
                    &.each-other {
                        background: #c4c6cc;
                        border-color: #c4c6cc;
                        color: #fff;
                        &:hover {
                            border-color: #c4c6cc;
                            background: #c4c6cc;
                        }
                    }
                }
            }
        }
    }
</style>
>>>>>>> b1c6a41 ([deploy]: 添加官方账号标识)



// WEBPACK FOOTER //
// my_attention.vue?376dd0b8